module.exports = __webpack_public_path__ + "img/footerc_508.6ebdd099.jpg";